import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import withV4IndexPriority from '../../../styles/withV4IndexPriority'
import { Theme } from '@mui/material/styles'
import { Typography } from '@dg-shared'
import { TranslatedTextType } from '../../../types'
import CustomSwitch from '@dg-shared/layouts/CustomSwitch'
import {
  AUTH_AGENT,
  AUTH_CHOICE,
  DONE,
  ERROR,
  FAILURE,
  MILEAGE,
  POLICY_DONE,
  REGULAR,
} from '../../../constants'
import { getDataComponentName } from '@dg-util'

export const useStyles = makeStyles()((theme: Theme) =>
  withV4IndexPriority({
    headerTextWrapper: {
      ...theme.brand.assets.layout?.customHeaderTextWrapper,
    },

    headerTitleStyle: {
      whiteSpace: 'pre-line',
      lineHeight: '1.3',
      ...theme.brand.assets.layout?.mobileCustomHeadingText,
      [theme.breakpoints.down('lg')]: {
        ...theme.brand.assets.layout?.mobileCustomTitle,
      },
    },

    headerSubTitleStyle: {
      whiteSpace: 'pre-line',
      lineHeight: '1.3',
      ...theme.brand.assets.layout?.mobileCustomHeadingText,
      [theme.breakpoints.down('lg')]: {
        ...theme.brand.assets.layout?.mobileCustomSubTitle,
      },
    },
  })
)

type MobileHeaderTextPropsType = {
  headerTitle?: TranslatedTextType
  headerSubTitle?: TranslatedTextType
  headerClass?: string
}

const MobileHeaderText: FC<MobileHeaderTextPropsType> = ({
  headerTitle,
  headerSubTitle,
  headerClass = '',
}) => {
  const { classes } = useStyles()
  const showTextOn = [AUTH_CHOICE, MILEAGE, ERROR, DONE, FAILURE, REGULAR, AUTH_AGENT, POLICY_DONE]

  return (
    <CustomSwitch showOn={showTextOn}>
      <div
        className={classes.headerTextWrapper}
        data-componentname={getDataComponentName(__filename)}
      >
        {!!headerTitle && (
          <Typography type='h2' className={`${classes.headerTitleStyle} ${headerClass}`}>
            {headerTitle}
          </Typography>
        )}
        {!!headerSubTitle && (
          <CustomSwitch showOn={[AUTH_CHOICE, REGULAR, FAILURE, MILEAGE, DONE, POLICY_DONE]}>
            <Typography className={classes.headerSubTitleStyle} type='h3'>
              {headerSubTitle}
            </Typography>
          </CustomSwitch>
        )}
      </div>
    </CustomSwitch>
  )
}

export default MobileHeaderText
